import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Logo from "../../Assets/images/Zlogo.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Dashboardimg from "../../Assets/images/Category.svg";
import Buys from "../../Assets/images/Activity.png";
import Saves from "../../Assets/images/Graph.png";
import Listings from "../../Assets/images/b2.png";
import note from "../../Assets/images/note.svg";
import Wallets from "../../Assets/images/Wallet.png";
import Bank from "../../Assets/images/card.png";
import Noti2 from "../../Assets/images/noti6.svg";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import getServices from "../../Services/get-service";
import cookie from "react-cookies";
import Routess from "./Routes";
import Save from "../../Assets/images/save.svg";
import Notification from "../../Components/Dashboard/Notification";
import Rental from "../Rentals";
import Skeleton from "@mui/material/Skeleton";
import DashboardSkeleton from "../../Components/SkeletonComponent/DashboardSkeleton";
import Constant from "../../Constant";
import { UserContext } from "../../Context/UserContext";

const drawerWidth = 240;
function Dashboard(props) {
  const { window: windowProp } = props;
  const { userDetails, isLoggedIn, loading } = useContext(UserContext);
  const navigate = useNavigate();
  const userData = userDetails || {};
  const location = useLocation();
  const [year, setYear] = useState("");

  useEffect(() => {
    const date = new Date();
    setYear(date.getFullYear());
  }, []);

  useEffect(() => {
    if (!isLoggedIn && !loading) {
      navigate("/");
    }
  }, [isLoggedIn, loading, navigate]);

  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const handleOpenNotification = () => setIsNotificationOpen(true);

  const [open, setOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [notiCount, setNotiCount] = useState(0);
  const fetchUnreadCount = async () => {
    try {
      const response = await getServices.getUnreadNotificationCount();
      if (response.data && response.data.data !== undefined) {
        const count =
          typeof response.data.data === "object"
            ? response.data.data.unreadCount
            : response.data.data;
        setNotiCount(Number(count) || 0);
      }
    } catch (error) {
      console.error("Error fetching unread count", error);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      fetchUnreadCount();
    }
  }, [isLoggedIn]);

  const handleCloseNotification = () => {
    setIsNotificationOpen(false);
    fetchUnreadCount(); // Refresh count when modal is closed
  };

  const [sidebar] = useState([
    {
      name: "Dashboard",
      icon: (
        <img src={Dashboardimg} className=" inline-block" alt="Dashboard" />
      ),
      link: "/dashboard",
      id: "dashbord",
    },
    {
      name: "Buy",
      icon: <img src={Buys} className=" inline-block" alt="buy" />,
      link: "/buy",
      id: "buy",
    },

    {
      name: "Save",
      icon: <img src={Saves} className=" inline-block" alt="Save" />,
      link: "/save",
      id: "save",
    },

    {
      name: "Listings",
      icon: <img src={Listings} className=" inline-block" alt="Listings" />,
      link: "/listings",
      id: "listings",
    },
    {
      name: "Rentals",
      icon: <img src={note} className=" inline-block" alt="note" />,
      link: "/rental/active",
      id: "rental",
    },
    {
      name: "Wallet",
      icon: <img src={Wallets} className=" inline-block" alt="Wallet" />,
      link: "/wallet",
      id: "wallet",
    },
    {
      // name: "Banks & Cards",
      name: "Banks",
      icon: <img src={Bank} className=" inline-block" alt="Banks & Cards" />,
      link: "/bankcards",
      id: "bankcard",
    },
    {
      name: "Settings",
      icon: <SettingsIcon />,
      link: "/settings",
      id: "settings",
    },
    {
      name: "Logout",
      icon: <LogoutIcon />,
      link: "/logout",
      id: "logout",
      mobileOnly: true,
      color: "#FF5959",
    },
  ]);
  const drawer = (
    <div>
      <div className=" pt-2 border-b border-b-gray-300 mb-2 pb-4 bg-[#F8FAFC]  ">
        <img src={Logo} alt="logo" className="  mx-auto" />
      </div>

      <List>
        {sidebar.map((text, index) => (
          <NavLink
            key={text.id || index}
            className={({ isActive }) => {
              return (
                " p-3 mb-3 pl-6 block " +
                (text.mobileOnly ? " sm:hidden mt-10 " : " ") +
                (!isActive
                  ? " "
                  : " bg-[#FDFDFE] border-l-4  border-l-primary-color text-back-color2 ")
              );
            }}
            style={({ isActive }) => ({
              color: text.color && !isActive ? text.color : "inherit",
            })}
            to={text.link}
          >
            {text.icon}
            <span className=" pl-3">{text.name}</span>
          </NavLink>
        ))}
      </List>
      <div className=" mt-40">
        <p className=" text-primary-color6 text-center">
          {" "}
          ©️ {year} - Zouse v1{" "}
        </p>
      </div>
    </div>
  );
  const convertToTitleCase = Constant.convertToTitleCase;

  const container =
    windowProp !== undefined ? () => windowProp().document.body : undefined;

  return (
    <div>
      <Notification
        open={isNotificationOpen}
        handleClose={handleCloseNotification}
        refreshCount={fetchUnreadCount}
      />
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          elevation={0}
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
            backgroundColor: "#F8FAFC",
          }}
        >
          <div className=" flex justify-between">
            <div className=" flex justify-between">
              <Toolbar>
                <IconButton
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{ mr: 2, display: { sm: "none" } }}
                >
                  <MenuIcon />
                </IconButton>
              </Toolbar>
              <div className=" flex flex-col justify-center">
                <p className=" text-black md:text-[24px] capitalize font-[400]">
                  {userDetails && userData.firstName ? (
                    `Welcome ${convertToTitleCase(userData.firstName)}!`
                  ) : (
                    <Skeleton width={200} />
                  )}
                </p>
              </div>
            </div>

            <div className=" md:flex hidden justify-center gap-2">
              <div className=" flex flex-col justify-center">
                <Link to={"/saveproducts"}>
                  <img
                    src={Save}
                    className=" inline-block"
                    height={"25"}
                    width="25"
                    alt="buy"
                  />
                </Link>
              </div>

              <div
                className="pt-5 relative cursor-pointer"
                onClick={handleOpenNotification}
              >
                <img
                  src={Noti2}
                  className=" inline-block"
                  width="25"
                  alt="Notification"
                />
                {notiCount > 0 && (
                  <span className="absolute top-4 -right-1 bg-red-600 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full border-2 border-white">
                    {notiCount > 9 ? "9+" : notiCount}
                  </span>
                )}
              </div>

              <div
                className=" mt-3 flex gap-2 mr-3 relative cursor-pointer"
                onClick={() => setOpen(!open)}
              >
                <div>
                  {userDetails && userData.profilePicture ? (
                    <img
                      src={userData.profilePicture}
                      alt="profile"
                      className="w-10 h-10 rounded-full object-cover"
                    />
                  ) : (
                    <p className="px-3 py-2 rounded-[44px] bg-back-color2 text-white">
                      {userDetails && userData.firstName ? (
                        userData?.firstName?.charAt(0) || ""
                      ) : (
                        <Skeleton variant="circular" width={32} height={32} />
                      )}
                    </p>
                  )}
                </div>
                <div>
                  <p className=" text-black inline-block text-[16px] mr-4 min-w-[100px]">
                    {userDetails && userData.firstName && userData.lastName ? (
                      `${convertToTitleCase(userData.firstName)} ${convertToTitleCase(userData.lastName)}`
                    ) : (
                      <Skeleton width={100} />
                    )}
                  </p>
                  <p className=" text-back-color2 text-[12px]">
                    {userDetails && userData.emailAddress ? (
                      userData.emailAddress
                    ) : (
                      <Skeleton width={120} />
                    )}
                  </p>
                </div>
                <div className=" pt-2">
                  {open ? (
                    <ArrowDropUpIcon className=" text-back-color2" />
                  ) : (
                    <ArrowDropDownIcon className=" text-back-color2" />
                  )}
                  {open && (
                    <div className=" mt-3 absolute top-12 right-0 rounded-lg p-6 pr-16 shadow-md text-back-color2 bg-white">
                      <p className=" mb-4">
                        <Link to="/settings">
                          <SettingsIcon /> <span>Settings</span>
                        </Link>
                      </p>

                      <p className=" mb-4 text-red-500">
                        <Link to="/logout">
                          <LogoutIcon /> <span>Logout</span>
                        </Link>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Mobile-only saved products and notifications */}
            <div className=" flex md:hidden items-center gap-4 mr-4">
              <div className=" flex flex-col justify-center">
                <Link to={"/saveproducts"}>
                  <img
                    src={Save}
                    className=" inline-block"
                    height={"25"}
                    width="25"
                    alt="buy"
                  />
                </Link>
              </div>

              <div
                className="relative cursor-pointer flex items-center"
                onClick={handleOpenNotification}
              >
                <img
                  src={Noti2}
                  className=" inline-block"
                  width="25"
                  alt="Notification"
                />
                {notiCount > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 bg-red-600 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full border-2 border-white">
                    {notiCount > 9 ? "9+" : notiCount}
                  </span>
                )}
              </div>
            </div>
          </div>
        </AppBar>
        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                backgroundColor: "white",
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                backgroundColor: "white",
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 2, sm: 3 },
            width: { xs: '100%', sm: `calc(100% - ${drawerWidth}px)` },
            maxWidth: { xs: '100%', sm: `calc(100% - ${drawerWidth}px)` },
            minWidth: 0,
          }}
        >
          <Toolbar />
          <div className=" w-full">
            {userDetails && userDetails.firstName ? (
              <Routess />
            ) : isLoggedIn ? (
              <DashboardSkeleton />
            ) : null}
          </div>
        </Box>
      </Box>
    </div>
  );
}
Dashboard.propTypes = {
  window: PropTypes.func,
};

export default Dashboard;
